import { Component, OnInit, Inject, OnDestroy, AfterViewInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { WorkOrdersDataSource } from '../../datasources/work-orders-data-source';
import { ListComponent } from '../list.component';

@Component({
  selector: 'app-list-desktop',
  templateUrl: './list-desktop.component.html',
  styleUrls: ['./list-desktop.component.scss']
})
export class DesktopListComponent extends ListComponent implements AfterViewInit, OnInit, OnDestroy {

  dataSource: WorkOrdersDataSource;
  displayedColumns: string[] =
    ['projectName', 'projectNumber', 'customerName', 'workOrder', 'workOrderType', 'jobType', 'workOrderStatus', 'startDate', 'crew', 'action'];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  ngOnInit() {
    super.init();

    this.dataSource = new WorkOrdersDataSource(this.workOrderService);
    this.loadWorkOrders();
  }
  ngAfterViewInit(): void {
    // reset the paginator after sorting
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        tap(() => this.loadWorkOrders())
      )
      .subscribe();

    this.paginator.page
      .pipe(
        tap(() => this.loadWorkOrders())
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.sort.sortChange.unsubscribe();
    this.paginator.page.unsubscribe();
  }


loadWorkOrders() {
  this.dataSource.loadWorkOrders(this.filter, this.sort.active,
    this.sort.direction, this.paginator.pageIndex);
  }

  refreshSummary() {

    this.loadSummary();
    this.loadWorkOrders();
  }
}
